import React from "react"

import {
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core"
import { Delete as DeleteIcon } from "@material-ui/icons"
import { Attribute } from "@root/store/types"

const useStyles = makeStyles({
  table: {
    minWidth: 300,
  },
})

export interface Props {
  attributes: Attribute[]
  onRemoveAttribute(attr: Attribute): void
}

const AttributesTable: React.FC<Props> = ({
  attributes,
  onRemoveAttribute,
}) => {
  const classes = useStyles()

  return (
    <TableContainer>
      <Table className={classes.table} aria-label="Attributes">
        <TableHead>
          <TableRow>
            <TableCell>Type</TableCell>
            <TableCell>Key</TableCell>
            <TableCell>Value</TableCell>
            <TableCell align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {attributes.map((attr) => (
            <TableRow
              key={attr.key}
              data-qa-selector={`attribute-row-${attr.key}`}
            >
              <TableCell>{attr.type}</TableCell>
              <TableCell>{attr.key}</TableCell>
              <TableCell>{attr.value}</TableCell>
              <TableCell align="right" padding="none" size="small">
                <IconButton
                  onClick={() => onRemoveAttribute(attr)}
                  data-qa-selector="delete"
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default AttributesTable
